import React from "react";
import { createRoot } from "react-dom/client";
import NeonRedirect from "neon-frontend-utils/src/components/NeonRedirect";

const RedirectRenderer = {
    render(path, refresh, history) {
        const rootElement = document.getElementById("root");

        if (rootElement) {
            const root = createRoot(rootElement);

            root.render(<NeonRedirect history={history} refresh={refresh} to={path} />);
        }
    },
};

export default RedirectRenderer;
